<template>
	<div id="pembayaran-detail">
    <!-- begin breadcrumb -->
		<ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>Pembayaran</li>
      <li>
        <router-link :to="{path: '/ticket-usage'}">List Ticket Usage</router-link>
      </li>
      <li class="active">Detail Ticket Usage</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Detail Ticket Usage</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">User ID : {{ data.user_id }}</h4>
          </div>
          <div class="panel-body">
            <!-- begin form -->
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Title</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.title" readonly>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Type</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.type" readonly>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Username</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.user_name" readonly>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Email</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.user_email" readonly>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Tiket Tersisa</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.ticket" readonly>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Tiket yang Digunakan</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.value" readonly>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Deskripsi</label>
                  <div class="col-md-8 col-xs-12">
                    <textarea class="form-control" v-model="data.description" readonly></textarea>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Picture</label>
                  <div class="col-md-8 col-xs-12">
                    <img class="img-fluid" v-if="data.picture" :src="data.picture" />
                  </div>
                </div>
              </div>
            </form>
            <!-- end form -->
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
	</div>
</template>

<script>
import SalesService from '@/services/sales.js'
import Spinner from '@/components/plugins/Spinner'

export default {
  name: 'ticket-usage-detail',
  components: {
    'app-spinner': Spinner,
  },
  data: function () {
    return {
      queryId: null,
      errors: [],
      isLoading: false,
      data: {
        user_id: null,
        title: null,
        type: null,
        user_name: null,
        user_email: null,
        ticket: null,
        value: null,
        description: null,
        picture: null,
      }
    }
  },
  mounted: function () {
    this.queryId = this.$route.query.id
    this.fetchData()
  },
  methods: {
    fetchData: function () {
      var id = this.queryId
      var context = this

      this.isLoading = true

      SalesService.getTicketUsageDetail(id, function (result) {
        context.isLoading = false

        if (result.success) {
          context.data.user_id = result.data.user_id
          context.data.title = result.data.title
          context.data.type = result.data.type
          context.data.user_name = result.data.user_name
          context.data.user_email = result.data.user_email
          context.data.ticket = result.data.ticket
          context.data.value = result.data.value
          context.data.description = result.data.description
          context.data.picture = result.data.picture
        } else {
          alert('Terjadi Kesalahan : ' + result.message)
        }
      })
    },
  }
}
</script>


// WEBPACK FOOTER //
// TicketUsageDetail.vue?6861ff03